import React from 'react';
import Render from './Render'


function App() {
  return (
    <div className="App">
      <Render />
    </div>
  );
}

export default App;